import {
    HiOutlineMail,
    HiOutlineChatAlt,
    HiOutlineUserAdd,
    HiOutlineClock,
    HiOutlineDocumentText,
    HiOutlineUsers,
    HiOutlineRefresh,
} from "react-icons/hi";
import { Link, useLocation } from "react-router-dom";
import { useCustomers } from "../../context/CustomerContext";
import { useSparrowCredit } from "../../context/SparrowCreditContext";

export default function MessageSidebar() {
    const { customers } = useCustomers();
    const { pathname } = useLocation();

    const { creditInfo, creditLoading, creditError } = useSparrowCredit();

    const items = [
        { id: "history", label: "Message History", icon: <HiOutlineClock size={18} />, path: "/messages/history" },
        { id: "compose-mail", label: "Bulk Mail", icon: <HiOutlineMail size={18} />, path: "/messages/compose-mail" },
        { id: "compose-sms", label: "Bulk SMS", icon: <HiOutlineChatAlt size={18} />, path: "/messages/compose-sms" },
        { id: "customer-list", label: "Customer List", icon: <HiOutlineUsers size={18} />, path: "/messages/customer-list" },
        { id: "sync-customer", label: "Sync Customers", icon: <HiOutlineRefresh size={18} />, path: "/messages/sync-customer" },
        { id: "add-customer", label: "Create Customer", icon: <HiOutlineUserAdd size={18} />, path: "/messages/add-customer" },
        { id: "templates", label: "Message Template", icon: <HiOutlineDocumentText size={18} />, path: "/messages/templates" },
    ];

    const count = customers?.length || 0;

    const isActive = (route) => pathname.includes(route);

    return (
        <div className="bg-white rounded-lg shadow p-3 sticky top-6 text-center">
            <h3 className="text-lg font-semibold mb-2">Message Menu</h3>

            <div className="mb-3">
                <span className="text-gray-700 font-medium">Total Customers:</span>{" "}
                <span className="inline-block px-3 py-1 rounded-full bg-indigo-100 text-indigo-700 font-semibold">
                    {count}
                </span>
            </div>

            {creditLoading ? (
                <div className="border bg-blue-50 border-blue-200 text-gray-700 rounded p-3 mb-4 max-w-sm italic">
                    Loading credit info...
                </div>
            ) : creditError ? (
                <div className="border bg-red-50 border-red-200 text-red-600 rounded p-3 mb-4 max-w-sm">
                    {creditError}
                </div>
            ) : creditInfo ? (
                <div className="border border-blue-200 bg-blue-50 rounded p-3 max-w-sm">
                    <h3 className="font-semibold text-base text-gray-700 ">Sparrow Credits</h3>
                    <div className="font-semibold space-y-1 text-sm text-gray-600">
                        <div><span>Credits Available:</span> {creditInfo.credits_available}</div>
                        <div><span>Credits Consumed:</span> {creditInfo.credits_consumed}</div>
                        <div><span>Last Balance Added:</span> {creditInfo.last_balance_added}</div>
                    </div>
                </div>
            ) : (
                <div className="border border-blue-200 bg-blue-50 font-semibold text-gray-700 rounded p-3 mb-4 max-w-xl italic">
                    Credit info not available
                </div>
            )}

            <nav className="flex flex-col gap-2 mt-3">
                {items.map((it) => {
                    const active = isActive(it.id);

                    return (
                        <Link
                            key={it.id}
                            to={it.path}
                            className={`flex items-center justify-center space-x-2 p-2 rounded transition-all no-underline
                                ${active
                                    ? "bg-indigo-100 text-indigo-700 font-semibold"
                                    : "text-gray-700 hover:bg-indigo-50 hover:text-indigo-700"
                                }`}
                        >
                            {it.icon}
                            <span>{it.label}</span>
                        </Link>
                    );
                })}
            </nav>
        </div>
    );
}
